/* eslint-disable radix */
/* eslint-disable import/prefer-default-export */
export const usDateFormat = (absenceDate) => {
  const formattedDate = new Date(absenceDate);
  const absenceDateString = absenceDate;
  const absenceDateArray = absenceDateString.split('-');

  formattedDate.setDate(absenceDateArray[2]);
  formattedDate.setFullYear(absenceDateArray[0]);
  formattedDate.setMonth(parseInt(absenceDateArray[1]) - 1);

  let month = formattedDate.getMonth() + 1;
  if (month < 10) month = `0${month}`;

  let date = formattedDate.getDate();
  if (date < 10) date = `0${date}`;

  return `${month}/${date}/${formattedDate.getFullYear()}`;
};
